<div class="border-round-left-md
            border-round-right-md
            bg-black shadow-6
            pt-1 pl-2 pb-1 pr-2 container-top-nav
            xl:-mt-1 lg:-mt-1 -mt-2">
  <nav class="flex justify-content-between top-nav">
    <ul class="flex list-none mb-0 pl-0 cursor-pointer">
      <li class="inline-block relative no-underline mr-1 hover:bg-blue-900" >
        <img width="25px" class="mr-3" src="assets/icons/computer.png" (click)="goDashboard()">
        <ul class="flex flex-column list-none mb-0 w-10rem absolute min-w-min pt-1 bg-menu">
          <li class="pt-2 border-bottom-1 pl-2 border-bottom-solid border-blue-900 text-blue-900 text-base font-bold pt-2 cursor-default">{{'home'| translate}}</li>

          <li class="text-base text-black pl-2 cursor-pointer" (click)="goDashboard()">{{'edDashboard'| translate}}</li>
          <li class="text-base text-black pl-2 cursor-pointer" (click)="goToWebsite()">{{'industrialInfoHome'| translate}}</li>
        </ul>
      </li>

      <li class="inline-block relative no-underline mr-1 hover:bg-blue-900">
        <img width="25px" class="mr-3" [src]="getNotifyImageSrc()" (click)="showNotifications()">
        <ul class="flex flex-column list-none mb-0 w-14rem absolute min-w-min pt-1 bg-menu">
          <li class="pt-2 border-bottom-1 pl-2 border-bottom-solid border-blue-900 text-blue-900 text-base font-bold pt-2 cursor-default">{{'common.notifications'| translate}}</li>

          <li class="text-base text-black pl-2 cursor-pointer" (click)="showNotifications()">{{'common.showNotification'| translate}} ({{clientNotificationCount + serverNotificationCount}})</li>
        </ul>
      </li>

      <li class="inline-block relative no-underline mr-1 hover:bg-blue-900">
        <img width="25px" class="mr-3" src="assets/icons/loupe.png">
        <ul class="flex flex-column list-none mb-0 w-10rem absolute min-w-min pt-1 bg-menu">
          <li class="pt-2 border-bottom-1 pl-2 border-bottom-solid border-blue-900 text-blue-900 text-base font-bold pt-2 cursor-default">{{'common.entityScreens'| translate}}</li>

          @if (this.hasCompanyScreen) {
            <li class="text-base text-black pl-2 cursor-pointer" (click)="goCompany()">{{'common.company'| translate}}</li>
          }

          @if (this.hasSiteScreen || this.hasPipelineScreen|| this.hasTLineScreen) {
            <li class="text-base text-black pl-2 cursor-default flex justify-content-between">
              <div>{{'common.asset'| translate}}</div>
              <div class="flex-column justify-content-center">
                <span class='pi pi-play text-end align-self-end text-blue-600' ></span>
              </div>
              <ul class="flex flex-column list-none mb-0 w-10rem absolute min-w-min dropdown-right">
                @if (this.hasSiteScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goSite()">{{'common.site'|translate}}</li>
                }
                @if (this.hasPipelineScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goPipeline()">{{'common.pipeline'|translate}}</li>
                }
                @if (this.hasTLineScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goTLine()">{{'common.tline'|translate}}</li>
                }
              </ul>
            </li>
          }

          @if (this.hasPlantScreen) {
            <li class="text-base text-black pl-2 cursor-pointer" (click)="goPlant()">{{'common.plant'|translate}}</li>
          }

          @if (this.hasAreaScreen) {
            <li class="text-base text-black pl-2 cursor-pointer" (click)="goArea()">{{'common.area'|translate}}</li>
          }

          @if (this.hasUnitScreen) {
            <li class="text-base text-black pl-2 cursor-pointer" (click)="goUnit()">{{'common.unit'|translate}}</li>
          }

          @if (this.hasBoilerScreen || this.hasDriveScreen|| this.hasTankScreen || this.hasMEquipmentScreen|| this.hasOEquipmentScreen) {
            <li class="text-base text-black pl-2 cursor-default flex justify-content-between">
              <div>{{'common.equipment'| translate}}</div>
              <div class="flex-column justify-content-center">
                <span class='pi pi-play text-end align-self-end text-blue-600' ></span>
              </div>
              <ul class="flex flex-column list-none mb-0 w-10rem absolute min-w-min dropdown-right">
                @if (this.hasBoilerScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goBoiler()">{{'common.boiler'|translate}}</li>
                }
                @if (this.hasDriveScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goDrive()">{{'common.drive'|translate}}</li>
                }
                @if (this.hasTankScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goTank()">{{'common.tank'|translate}}</li>
                }
                @if (this.hasMEquipmentScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goMEquipment()">{{'common.miningEquipment'|translate}}</li>
                }
                @if (this.hasOEquipmentScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goOtherEquipment()">{{'common.otherEquipment'|translate}}</li>
                }
              </ul>
            </li>
          }

          @if (this.hasOfflineEventScreen) {
            <li class="text-base text-black pl-2 cursor-pointer" (click)="goOfflineEvent()">{{'common.offlineEvent'|translate}}</li>
          }

          @if (this.hasConfirmedProjectScreen || this.hasUnconfirmedProjectScreen) {
            <li class="text-base text-black pl-2 cursor-default flex justify-content-between">
              <div>{{'common.project'| translate}}</div>
              <div class="flex-column justify-content-center">
                <span class='pi pi-play text-end align-self-end text-blue-600' ></span>
              </div>
              <ul class="flex flex-column list-none mb-0 w-10rem absolute min-w-min dropdown-right">
                @if (this.hasConfirmedProjectScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goConfirmedProject()">{{'common.confirmedProject'|translate}}</li>
                }
                @if (this.hasUnconfirmedProjectScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goUnconfirmedProject()">{{'common.unconfirmedProject'|translate}}</li>
                }
                <li class="text-base text-black pl-2 cursor-pointer" (click)="goUmbrellaProject()">{{'common.umbrellaProject'|translate}}</li>
              </ul>
            </li>
          }

          @if (this.hasPlantLTSAScreen || this.hasUnitLTSAScreen|| this.hasPipelineLTSAScreen) {
            <li class="text-base text-black pl-2 cursor-default flex justify-content-between">
              <div>{{'common.agreements'| translate}}</div>
              <div class="flex-column justify-content-center">
                <span class='pi pi-play text-end align-self-end text-blue-600' ></span>
              </div>
              <ul class="flex flex-column list-none mb-0 w-10rem absolute min-w-min dropdown-right">
                @if (this.hasPlantLTSAScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goPlantLtsa()">{{'common.plantLtsa'|translate}}</li>
                }
                @if (this.hasUnitLTSAScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goUnitLtsa()">{{'common.unitLtsa'|translate}}</li>
                }
                @if (this.hasPipelineLTSAScreen) {
                  <li class="text-base text-black pl-2 cursor-pointer" (click)="goPipelineLtsa()">{{'common.pipelineLtsa'|translate}}</li>
                }
              </ul>
            </li>
          }

          @if (this.hasReleaseScreen) {
            <li class="text-base text-black pl-2 cursor-pointer" (click)="goRelease()">{{'common.release'|translate}}</li>
          }

        </ul>
      </li>

      <li class="inline-block relative no-underline mr-1 hover:bg-blue-900" >
        <img width="25px" class="mr-3" src="assets/icons/tools.svg">
        <ul class="flex flex-column list-none mb-0 w-10rem absolute min-w-min pt-1 bg-menu">
          <li class="pt-2 border-bottom-1 pl-2 border-bottom-solid border-blue-900 text-blue-900 text-base font-bold pt-2 cursor-default">{{'common.utilities'| translate}}</li>

          <li class="text-base text-black pl-2 cursor-pointer" (click)="goPreferences()" >{{'common.preferences'|translate}}</li>
          <li class="text-base text-black pl-2 cursor-pointer" (click)="goToWebsite('tools/callerid.jsp')">{{'setCallerId'| translate}}</li>
          <li class="text-base text-black pl-2 cursor-pointer" (click)="!this.showUpdateLink && updateCheck()" [class.disabled]="this.showUpdateLink">{{'updateCheck'| translate}}</li>
          @if (this.hasClearLockRole) {
            <li class="text-base text-black pl-2 cursor-pointer" (click)="openClearLockUtility()" >{{'clearLock.title'|translate}}</li>
          }
          @if (this.hasDevToolsRole) {
            <li class="text-base text-black pl-2 cursor-pointer" (click)="openDeveloperTools()" >{{'devTools.title'|translate}}</li>
          }
        </ul>
      </li>
      <li class="inline-block relative no-underline mr-1 hover:bg-blue-900" >
        <img width="25px" class="mr-3" src="assets/icons/qa.png">
        <ul class="flex flex-column list-none mb-0 w-10rem absolute min-w-min pt-1 bg-menu">
          <li class="pt-2 border-bottom-1 pl-2 border-bottom-solid border-blue-900 text-blue-900 text-base font-bold pt-2 cursor-default">{{'common.supportServices'| translate}}</li>

          <li class="text-base text-black pl-2 cursor-pointer" (click)="openGeographyRequest()">{{'geographyRequest.link'| translate}}</li>
          <li class="text-base text-black pl-2 cursor-pointer" (click)="goToWebsite('includes/getIIRSupportQuickRef.jsp')">{{'contactUs'| translate}}</li>
          <li class="text-base text-black pl-2 cursor-pointer" (click)="goToWebsite('manuals/edguide.jsp')">{{'edGuide'| translate}}</li>
        </ul>
      </li>

    </ul>
    @if (this.showUpdateLink) {
      <div class="upgrade-link">
        <span (click)="doUpdate()">Newer version available, update now!</span>
      </div>
    }
    <div id="headerDate" class="text-sm">
      <span devToolsEnabler (magicSpell)="openDeveloperTools()">{{ currentDate | ordinalDate }}</span>
    </div>
  </nav>
</div>
